import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propBool, propStr, propValidate, } from '../../../../helpers/custom-prop-types';
import FileInputFieldComponent from './FileInputFieldComponent';
const FileInputField = ({ accept, isDisabled, name, submitButtonClassName, validate, }) => (_jsx(Field, { accept: accept, component: FileInputFieldComponent, isDisabled: isDisabled, name: name, submitButtonClassName: submitButtonClassName, validate: validate }));
FileInputField.propTypes = {
    accept: propStr().isRequired,
    isDisabled: propBool().isRequired,
    name: propStr().isRequired,
    submitButtonClassName: propStr().isRequired,
    validate: propValidate(),
};
FileInputField.defaultProps = {
    validate: [],
};
export default FileInputField;
